module.exports = __webpack_public_path__ + "img/VIB.e928c901.svg";